var map = {
	"./danger-theme.png": 83649,
	"./info-theme.png": 48103,
	"./primary-theme.png": 12871,
	"./secondary-theme.png": 24657,
	"./success-theme.png": 66403,
	"./warning-theme.png": 78269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97998;